import { useState } from "react";

import { useWebsite } from "context/client/website";

import api from "libs/api";
import redirectToCheckout from "libs/helpers/redirectToCheckout";

const usePaymentVerification = () => {
  const { data, customerPortal } = useWebsite();
  const [loading, setLoading] = useState(false);

  const verify = async () => {
    try {
      setLoading(true);

      if (!!data?.subscription?.status) {
        customerPortal();
      } else {
        const continuePayment = await api.post(
          `/client/websites/${data?._id}/continue-payment`
        );
        redirectToCheckout(continuePayment);
      }
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  };

  return { verify, loading };
};

export default usePaymentVerification;
